<div class="alert alert-danger" *ngIf="companyNotFound; else registerTemplate">Registrazione non abilitata</div>
<ng-template #registerTemplate class="user-register-container">
    <ng-container [ngSwitch]="stepNumber">
        <!--STEP 1-->
        <ng-template [ngSwitchCase]="'1'">
            <div class="step-text">
                <h2 class="step-title">Tipologia di account</h2>
                <span class="step-subtitle">Se hai bisogno di informazioni, non esitare a contattarci</span>
            </div>
            <div class="cards row g-4">
                <div class="cards row g-4">
                    <div class="col-12 col-md-6">
                        <div class="card" [ngClass]="{'selected': typeOfAccount === typesOfAccount[1]}"
                             (click)="setTypeOfAccount(typesOfAccount[1])">
                            <div class="card-body">
                                <div class="card-icon">
                                    <i class="bi bi-people-fill"></i>
                                </div>
                                <div class="card-text">
                                    <span class="card-title">Genitore / Tutore</span>
                                    <span class="card-description">
                        Mi registro al portale per iscrivere mio figlio presso questa società
                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="card" [ngClass]="{'selected': typeOfAccount === typesOfAccount[0]}"
                             (click)="setTypeOfAccount(typesOfAccount[0])">
                            <div class="card-body">
                                <div class="card-icon">
                                    <i class="bi bi-person-check-fill"></i>
                                </div>
                                <div class="card-text">
                                    <span class="card-title">Atleta maggiorenne</span>
                                    <span class="card-description">
                        Sono maggiorenne e desidero iscrivermi alla società sportiva
                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="continue-step-btn buttons d-flex justify-content-end">
                <div class="btn btn-secondary" *ngIf="stepNumber !== 1" (click)="previousStep()">
                    Indietro
                </div>
                <div class="btn-procedi" (click)="nextStep()">Continua</div>
            </div>
        </ng-template>
        <!--STEP 2-->
        <ng-template [ngSwitchCase]="'2'">
            <ng-container [ngSwitch]="typeOfAccount">
                <ng-template [ngSwitchCase]="typesOfAccount[1]">
                    <div class="step-text">
                        <h2 class="step-title">Informazioni Genitore/Tutore</h2>
                        <span class="step-subtitle">Per poter iscrivere tuo figlio presso la società sportiva devi registrarti.</span>
                    </div>
                    <div class="step-form">
                        <form #userTutorForm="ngForm" class="row g-3">
                            <div class="col-md-6">
                                <label for="user-parent-firstname"
                                       class="form-label required">Nome</label>
                                <input type="text" class="form-control" id="user-parent-firstname"
                                       [(ngModel)]="newUser.firstName"
                                       name="user-parent-firstname"
                                       required
                                >
                            </div>
                            <div class="col-md-6">
                                <label for="user-parent-lastname"
                                       class="form-label required">Cognome</label>
                                <input type="text" class="form-control" id="user-parent-lastname"
                                       [(ngModel)]="newUser.lastName"
                                       name="user-parent-lastname"
                                       required
                                >
                            </div>
                            <div class="col-md-6">
                                <label for="user-parent-email" class="form-label required">Email</label>
                                <input type="email" class="form-control" id="user-parent-email"
                                       [(ngModel)]="newUser.email" [ngModelOptions]="{standalone: true}"
                                       #email="ngModel" email required>

                                <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">
                                    <div *ngIf="email.errors?.['required']">
                                        L'email è obbligatoria.
                                    </div>
                                    <div *ngIf="email.errors?.['email']">
                                        Inserisci un indirizzo email valido.
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label for="user-parent-phone" class="form-label required">Telefono</label>
                                <input type="text" class="form-control" id="user-parent-phone"
                                       [(ngModel)]="newUser.phone" [ngModelOptions]="{standalone: true}"
                                       #phone="ngModel" required pattern="[0-9]*">

                                <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="alert alert-danger">
                                    <div *ngIf="phone.errors?.['required']">
                                        Il numero di telefono è obbligatorio.
                                    </div>
                                    <div *ngIf="phone.errors?.['pattern']">
                                        Inserisci un numero di telefono valido.
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label for="user-parent-password"
                                       class="form-label required">Codice Fiscale</label>
                                <input type="text" class="form-control form-control-solid text-uppercase" id="user-parent-fiscalCode"
                                       [(ngModel)]="newUser.fiscalCode"
                                       name="user-parent-fiscalCode"
                                       maxlength="16"
                                       required
                                >
                            </div>
                            <div class="col-md-6">
                                <label for="user-parent-password"
                                       class="form-label required">Password</label>
                                <div class="input-group">
                                    <input type="password" class="form-control" id="user-parent-password"
                                           [(ngModel)]="newUser.password"
                                           [type]="showPassword ? 'text' : 'password'"
                                           name="user-parent-password"
                                           required
                                    >
                                    <button class="btn btn-outline-secondary" (click)="showPassword=!showPassword"
                                            type="button">
                                        <i class="fa fa-eye"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="tutor-document-front"
                                       class="form-label required">Fronte carta d'identità</label>
                                <input type="file" class="form-control form-control-solid" id="tutor-document-front"
                                       aria-describedby="tutor-document-front" aria-label="Upload"
                                       (change)="chooseDocumentFront($event)"
                                       [(ngModel)]="newUser.documentUrlFront"
                                       [ngModelOptions]="{standalone: true}"
                                       required
                                />
                                <div *ngIf="responseFront">
                                    <a [href]="responseFront">Visualizza il documento caricato</a>
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="tutor-document-back"
                                       class="form-label required">Retro carta d'identità</label>
                                <input type="file" class="form-control form-control-solid" id="tutor-document-back"
                                       aria-describedby="tutor-document-back" aria-label="Upload"
                                       (change)="chooseDocumentBack($event)"
                                       [(ngModel)]="newUser.documentUrlBack"
                                       [ngModelOptions]="{standalone: true}"
                                       required
                                />
                                <div *ngIf="responseBack">
                                    <a [href]="responseBack">Visualizza il documento caricato</a>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="continue-step-btn buttons">
                        <div class="btn welldone-btn-light"
                             (click)="previousStep()">
                            Indietro
                        </div>
                        <button class="btn-procedi"
                                #disableBtn
                                [disabled]="!parentIsValid(newUser)"
                                (click)="nextStep()">Continua
                        </button>
                    </div>
                </ng-template>
                <ng-template [ngSwitchCase]="typesOfAccount[0]">
                    <div class="step-text">
                        <h2 class="step-title">Atleta maggiorenne</h2>
                        <span class="step-subtitle">Per poterti iscrivere, devi prima registrarti.</span>
                    </div>
                    <div class="step-form">
                        <form class="row g-3">
                            <div class="col-md-6">
                                <label for="user-firstname" class="form-label required">Nome</label>
                                <input type="email" class="form-control" id="user-firstname"
                                       [(ngModel)]="newUser.firstName"
                                       [ngModelOptions]="{standalone: true}">
                            </div>
                            <div class="col-md-6">
                                <label for="user-lastname" class="form-label required">Cognome</label>
                                <input type="text" class="form-control" id="user-lastname"
                                       [(ngModel)]="newUser.lastName"
                                       [ngModelOptions]="{standalone: true}">
                            </div>
                            <div class="col-md-6">
                                <label for="user-email" class="form-label required">Email</label>
                                <input type="email" class="form-control" id="user-email"
                                       [(ngModel)]="newUser.email"
                                       [ngModelOptions]="{standalone: true}">
                            </div>
                            <div class="col-md-6">
                                <label for="user-phone" class="form-label required">Telefono</label>
                                <input type="text" class="form-control" id="user-phone"
                                       [(ngModel)]="newUser.phone"
                                       [ngModelOptions]="{standalone: true}">
                            </div>
                            <div class="col-12">
                                <label for="user-password" class="form-label required">Password</label>
                                <div class="input-group">
                                    <input [type]="showPassword ? 'text' : 'password'"
                                           class="form-control" id="user-password"
                                           [(ngModel)]="newUser.password"
                                           [ngModelOptions]="{standalone: true}">
                                    <button class="btn btn-outline-secondary" (click)="showPassword=!showPassword"
                                            type="button">
                                        <i class="fa fa-eye"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="continue-step-btn buttons">
                        <div class="btn welldone-btn-light" *ngIf="stepNumber !== 1"
                             (click)="previousStep()">
                            Indietro
                        </div>
                        <button class="btn-procedi"
                                #disableAdultBtn
                                [disabled]="!(newUser.firstName && newUser.lastName && newUser.email && newUser.phone && newUser.password) "
                                (click)="nextStep()">Continua
                        </button>
                    </div>
                </ng-template>
            </ng-container>
        </ng-template>
        <!--STEP 3-->
        <ng-template [ngSwitchCase]="'3'">
            <div class="step-text" style="margin-bottom: 1rem !important;">
                <h2 class="step-title">Informazioni atleta </h2>
                <span class="step-subtitle">Inserisci qui i dati relativi all'atleta o agli atleti che vuoi iscrivere presso la nostra società sportiva.</span>
            </div>
            <button *ngIf="typeOfAccount === typesOfAccount[1]" class="btn-procedi"
                    style="margin-bottom: 1.5rem;"
                    (click)="openModal()">
                <i class="bi bi-person-plus-fill me-2"></i>Aggiungi Atleta
            </button>

            <div class="athletes-list">
                <ng-container *ngIf="listOfAthletes.length > 0">
                    <p class="athletes-list-text fw-bold text-muted small text-uppercase mb-3">Profili atleta da
                        iscrivere:</p>
                    <div class="card-list">
                        <ng-container *ngFor="let athlete of listOfAthletes; let i = index;">
                            <div class="card">
                                <div class="card-body">
                                    <div class="athlete-data">
                                        <span class="athlete-name"> {{ athlete.firstName }} {{ athlete.lastName }}</span>
                                        <div class="athlete-details">
                                            <span><i
                                                    class="bi bi-calendar-event me-1"></i>  {{ athlete.bornDate ? (athlete.bornDate | date:'dd/MM/yyyy') : 'Non inserito' }}</span>
                                            <span><i
                                                    class="bi bi-geo-alt me-1"></i>{{ athlete.bornCity || 'Non inserito' }} </span>
                                            <span><i
                                                    class="bi bi-card-text me-1"></i>{{ athlete.fiscalCode || 'Non inserito' }}</span>
                                            <span><i
                                                    class="bi bi-globe me-1"></i>{{ getCitizenshipName(athlete.citizenshipType) || 'Non inserito' }}</span>
                                            <span class="badge"
                                                  [ngClass]="athlete.alreadyPlayedInCompany ? 'badge-success' : 'badge-warning'">
                                                {{ athlete.alreadyPlayedInCompany ? 'Già Tesserato' : 'Nuovo Tesseramento' }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="athlete-buttons">
                                        <button class="btn welldone-btn-light btn-sm" (click)="editAthlete(i)">
                                            <i class="bi bi-pencil-fill me-1"></i>Modifica
                                        </button>
                                        <button *ngIf="typeOfAccount === typesOfAccount[1]"
                                                class="btn welldone-btn-danger btn-sm" (click)="deleteAthlete(i)">
                                            <i class="bi bi-trash-fill me-1"></i>Elimina
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </ng-container>
            </div>
            <div *ngIf="listOfAthletes.length === 0" class="alert alert-danger py-3 text-center">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>Aggiungi almeno un atleta per continuare
            </div>
            <div class="continue-step-btn buttons">
                <div class="btn welldone-btn-light" *ngIf="stepNumber !== 1" (click)="previousStep()">Indietro
                </div>
                <button class="btn-procedi"
                        [disabled]="listOfAthletes.length === 0 || !checkAthletesAreValid()"
                        (click)="nextStep()">Continua
                </button>
            </div>
        </ng-template>
        <!--STEP 4-->
        <ng-template [ngSwitchCase]="'4'">
            <div class="step-text" style="padding-top: 4rem; margin-bottom: 1rem !important;">
                <h2 class="step-title">
                    Termini e condizioni del <span class="gradient-text">servizio</span>
                </h2>
                <span class="step-subtitle">Per poter accedere ai nostri servizi devi leggere e accettare i termini e condizioni forniti.</span>
            </div>
            <div class="border rounded-3 p-3 bg-light mb-3">
                <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="termsandconditions"
                           [(ngModel)]="termsAndConditionAccepted">
                    <label class="form-check-label" for="termsandconditions">
                        * Dichiaro di aver letto, compreso e di accettare i <a href="assets/pdf/terms_utente.pdf"
                                                                               target="_blank">Termini e condizioni del
                        servizio</a>
                    </label>
                </div>
            </div>
            <div class="border rounded-3 p-3 bg-light mb-3">
                <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="privacy"
                           [(ngModel)]="privacyAccepted">
                    <label class="form-check-label" for="privacy">
                        * Dichiaro di aver preso visione dell’informativa <a href="assets/pdf/privacy.pdf"
                                                                             target="_blank">privacy</a>
                    </label>
                </div>
            </div>
            <div class="border rounded-3 p-3 bg-light mb-3">
                <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="company-rules"
                           [(ngModel)]="companyRulesAccepted">
                    <label class="form-check-label" for="company-rules">
                        * Dichiaro di aver preso visione del <a [href]="companyRules">regolamento societario</a>
                    </label>
                </div>
            </div>

            <div class="continue-step-btn buttons">
                <div class="btn wellxdone-btn-light" *ngIf="stepNumber !== 1" (click)="previousStep()">
                    Indietro
                </div>
                <button class="btn-procedi" (click)="sendRegistrationUser()"
                        [disabled]="!(termsAndConditionAccepted && privacyAccepted && companyRulesAccepted && disableContinueButton)">
                    Continua
                </button>
            </div>
        </ng-template>
        <!--STEP 5-->
        <ng-template [ngSwitchCase]="'5'">
            <div class="step-text" style="padding-top: 4rem; margin-bottom: 1rem !important;">
                <h2 class="step-title">Conferma operazione</h2>
                <span class="step-subtitle">Per procedere e confermare l'attivazione inserisci il codice OTP che ti abbiamo inviato via email.</span>
            </div>
            <div class="form-check" style="padding-left: 0;">
                <label class="form-check-label required" for="company-OTP">
                    Codice OTP
                </label>
                <input type="text" class="form-control" id="company-OTP"
                       [(ngModel)]="OTPCode"/>
            </div>
            <div class="continue-step-btn buttons">
                <button class="btn-procedi"
                        (click)="checkOTP(OTPCode, newUser.email)"
                >
                    Continua
                </button>
            </div>
        </ng-template>
        <ng-template [ngSwitchCase]="'6'">
            <div class="step-text text-center">
                <div class="mb-4">
                    <i class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></i>
                </div>
                <h2 class="step-title">Registrazione completata!</h2>
                <span class="step-subtitle" *ngIf="!manualOnboarding">Congratulazioni, la tua richiesta è stata presa in carico correttamente.</span>
                <span class="step-subtitle" *ngIf="manualOnboarding">L'atleta è stato registrato e attivato correttamente.</span>
            </div>
            <div class="notice-card mt-4" *ngIf="!manualOnboarding">
                <div class="notice-icon">
                    <i class="bi bi-info-circle-fill text-warning fs-2"></i>
                </div>
                <div class="notice-text">
                    <h4 class="notice-title">Cosa succede ora?</h4>
                    <div class="notice-description">
                        L'amministrazione della società sportiva dovrà verificare i dati inseriti e
                        accettare l'iscrizione degli atleti. Riceverai una notifica email con l'esito della verifica e
                        le istruzioni per procedere al pagamento.
                    </div>
                </div>
            </div>
            <div class="notice-card mt-4" *ngIf="manualOnboarding">
                <div class="notice-icon">
                    <i class="bi bi-info-circle-fill text-success fs-2"></i>
                </div>
                <div class="notice-text">
                    <h4 class="notice-title">Cosa succede ora?</h4>
                    <div class="notice-description">
                        L'utente può accedere alla piattaforma e procedere con il pagamento dell'iscrizione.
                        È stata inviata una notifica email con le istruzioni.
                    </div>
                </div>
            </div>
            <div class="buttons d-flex justify-content-center mt-5">
                <div class="btn-procedi" (click)="backToLogin()">
                    {{ manualOnboarding ? 'Torna all\'elenco atleti' : 'Torna al login' }}
                </div>
            </div>
        </ng-template>
        <ng-template ngSwitchDefault>Not a valid Step</ng-template>
    </ng-container>
</ng-template>


<div class="testtest">
    <ngx-smart-modal #addAthlete identifier="addAthlete" [closable]="true" [dismissable]="false">
        <div class="welldone-card-header">
            {{ isEditingAthlete ? 'Modifica atleta' : 'Aggiungi atleta' }}
        </div>
        <div class="welldone-card-body">
            <div class="step-form w-100">
                <form #addAthleteForm="ngForm" class="row g-3">
                    <div class="col-md-6">
                        <label for="new-name" class="form-label required">Nome</label>
                        <input type="text" class="form-control form-control-solid" id="new-name"
                               [(ngModel)]="newAthlete.firstName" name="firstName" required>
                    </div>
                    <div class="col-md-6">
                        <label for="new-surname" class="form-label required">Cognome</label>
                        <input type="text" class="form-control" id="new-surname" name="lastname" required
                               [(ngModel)]="newAthlete.lastName">
                    </div>
                    <div class="col-md-6">
                        <label for="birthday" class="form-label required">Data di nascita</label>
                        <input type="date" class="form-control form-control-solid" id="birthday" required
                               name="bornDate" [(ngModel)]="newAthlete.bornDate">
                    </div>
                    <div class="col-md-6">
                        <label for="new-phone" class="form-label required">Nato a</label>
                        <input type="text" class="form-control form-control-solid" id="new-phone" required
                               name="bornCity" [(ngModel)]="newAthlete.bornCity">
                    </div>
                    <div class="col-md-12">
                        <label for="new-username" class="form-label required">Codice Fiscale</label>
                        <input type="text" class="form-control form-control-solid text-uppercase" id="new-username"
                               minlength="16" maxlength="16"
                               [(ngModel)]="newAthlete.fiscalCode"
                               pattern="[a-zA-Z0-9]{16}" #fiscalCode="ngModel"
                               name="fiscalCode">
                        <div *ngIf="fiscalCode.invalid && (fiscalCode.dirty || fiscalCode.touched)"
                             class="alert alert-danger mt-2">
                            <div *ngIf="fiscalCode.errors?.['pattern']">
                                Il codice fiscale deve essere di 16 caratteri alfanumerici.
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <label for="new-athlete-citizenship-type" class="form-label required">Nazionalità</label>
                        <select class="form-control form-select form-select-solid" id="new-athlete-citizenship-type"
                                [(ngModel)]="newAthlete.citizenshipType"
                                name="athlete-citizenship-type"
                                required>
                            <option value="" selected>Seleziona una tipologia</option>
                            <option *ngFor="let type of citizenshipTypes" [value]="type.id">
                                {{ type.name }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 mt-4">
                        <label class="form-label required fw-bold">Hai già giocato in questa società?</label>
                        <div class="d-flex gap-4">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="already-played" [value]="1"
                                       id="alreadyPlayedYes" required
                                       [(ngModel)]="newAthlete.alreadyPlayedInCompany"/>
                                <label class="form-check-label" for="alreadyPlayedYes">Sì</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="already-played" [value]="0"
                                       id="alreadyPlayedNo"
                                       [(ngModel)]="newAthlete.alreadyPlayedInCompany" required/>
                                <label class="form-check-label" for="alreadyPlayedNo">No</label>
                            </div>
                        </div>
                        <ng-container *ngIf="newAthlete.alreadyPlayedInCompany === 0">
                            <input type="text" class="form-control form-control-solid mt-2"
                                   [(ngModel)]="newAthlete.previousCompanyName"
                                   placeholder="Inserisci il nome dell'ultima società" name="previous-company-name"/>
                        </ng-container>
                    </div>

                    <div class="col-12 mt-4">
                        <label class="form-label required fw-bold">E' la prima volta che pratichi uno sport
                            agonistico?</label>
                        <div class="d-flex gap-4">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="first-time-agonistic" [value]="'1'"
                                       id="firstTimeAgonisticYes" required
                                       [(ngModel)]="newAthlete.firstTimeAgonistic"/>
                                <label class="form-check-label" for="firstTimeAgonisticYes">Sì</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="first-time-agonistic" [value]="'0'"
                                       id="firstTimeAgonisticNo"
                                       [(ngModel)]="newAthlete.firstTimeAgonistic" required/>
                                <label class="form-check-label" for="firstTimeAgonisticNo">No</label>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="welldone-card-footer">
            <button class="btn btn-secondary me-2" (click)="closeModal()">Annulla</button>
            <button class="btn-procedi"
                    (click)="addAthleteToList(newAthlete)"
                    [disabled]="addAthleteForm.invalid">{{ isEditingAthlete ? 'Aggiorna' : 'Aggiungi' }}
            </button>
        </div>
    </ngx-smart-modal>
</div>
